import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { PractitionerStatus } from '../../enums/practitioner-status.enum';
import { Practitioner } from '../../models/practitioner.model';
import { PractitionerService } from '../../services/practitioner.service';

@Component({
  selector: 'app-status-banner',
  templateUrl: './status-banner.component.html',
  styleUrls: ['./status-banner.component.scss']
})
export class StatusBannerComponent implements OnInit {
  @Input() practitioner: Practitioner;
  pendingUpdates: any;
  pendingUpdatesList: string[] = [];

  get practitionerStatusEnum(): typeof PractitionerStatus {
    return PractitionerStatus;
  }

  constructor(private practitionerService: PractitionerService) { }

  ngOnInit(): void {
    // this.loadPendingUpdates();
  }

  // loadPendingUpdates() {
  //   if (this.practitioner.status === PractitionerStatus.UpdatesPendingApproval) {
  //     this.practitionerService.getPendingUpdates(this.practitioner.id).then(snapshot => {
  //       this.pendingUpdates = snapshot.docs[0].data();
  //       this.setPendingUpdates();
  //     })
  //   }
  // }

  // setPendingUpdates() {
  //   let updates: string[] = [];
  //   Object.keys(this.pendingUpdates).forEach(key => {
  //     if (key !== 'approved' && key !== 'createdAt') {
  //       let stringValue = key + ': ' + this.formatValue(this.pendingUpdates[key], key);
  //       updates.push(stringValue);
  //      }
  //   });
  //   this.pendingUpdatesList = updates;
  // }

  formatValue(value: any, key: string): string {
    let formattedValue: string = value;
    if (key === 'location') {
      formattedValue = value.addressLines[0] + ', ' + value.locality + ', ' + value.administrativeArea + ' ' + value.postalCode;
    } else if (key === 'education') {
      formattedValue = '';
      value.forEach(val => {
        formattedValue += val.name + ', ' + val.degree + '<br>';
      });
    } else if (key === 'documents') {
      formattedValue = value.map(val => val.name).toString()
    } else if (formattedValue == 'false' || formattedValue == 'true') {
      formattedValue = formattedValue == 'false' ? 'No' : 'Yes';
    } else if (key === 'specialties') {
      formattedValue = '';
      value.forEach(specialty => {
        formattedValue += '<br>';
        formattedValue += '<b>' + specialty.name + ' Services</b>';
        specialty.therapies.forEach(therapy => {
          formattedValue += '<br>';
          formattedValue += therapy.name + ', £' + therapy.cost + ', ' + therapy.duration + ' minutes' + '<br><i>' + therapy.description + '</i>';
          formattedValue += '<br>';
        });
      });
    }
    return formattedValue;
  }
}
